export const breakpointNames = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xs1', 'xs2', 'xs3', 'xs4', 'xs5', 'sm5', 'md5', 'lg5', 'xl5'] as const;
export type BreakpointName = typeof breakpointNames[number];

export const breakpoints = new Map<BreakpointName, number>([
	// bootstrap $grid-breakpoints (rem)
	['xs', 0],
	['sm', 36],
	['md', 48],
	['lg', 62],
	['xl', 75],
	['xxl', 87.5],

	// custom breakpoints (rem)
	['xs1', 12.625],  // 1/10th between 320-576
	['xs2', 23.1875], // 2/10th between 320-576
	['xs3', 24.8125], // 3/10th between 320-576
	['xs4', 26.375],  // 4/10th between 320-576
	['xs5', 28],      // mid-point between 320 - 576
	['sm5', 42],      // mid-point between 576 - 768
	['md5', 55],      // mid-point between 758 - 992
	['lg5', 68.5],    // mid-point between 992 - 1200
	['xl5', 81.25],   // mid-point between 1200 - 1300
]);
